import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ApiService } from '../services/contratos/contratos.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscription, map, of, interval } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { format } from 'date-fns';
import { ClrModal } from '@clr/angular';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';
import { UsuarioLogado } from '../autenticacao/usuario-logado.type';
import { Router } from '@angular/router';
import { NumberArray } from 'd3';
import { DatePipe } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import moment from 'moment';
import * as ExcelJS from 'exceljs';
import * as fs from 'file-saver'; // Importe a biblioteca file-saver

interface LocationData {
  local: string;
  localDescarga: string;
  // Outras propriedades que você precisa
}

@Component({
  selector: 'app-time-table-scania',
  templateUrl: './time-table-scania.component.html',
  styleUrls: ['./time-table-scania.component.css'],
  standalone: false
})
export class TimeTableScaniaComponent {

  argentina!: any[];
  item: any = {
    ID: '',
    local: '',
    contato: '',
    endereco: '',
    latitude: '',
    longitude: '',
    descarga: false
  };
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsultaCompactada: string = 'https://q9hhz5wjah.execute-api.sa-east-1.amazonaws.com/volumeGD';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  query: string = 'Itens_Jetta';
  query2: string = 'Carriers';
  query3: string = 'tipos_Veiculos_Karrara';
  query4: string = 'items_Excel_Karrara';
  queryVW: string = 'items_Operacao_VW';
  queryInterplantas: string = 'Operacao_Interplantas_Karrara';
  queryTimeTable: string = 'janelasTimeTable';
  queryChegadasLCB: string = 'ChegadasNoLCB';
  queryTabelaContainerEXP: string = 'Container_exportacao';
  queryChegadasSCANIA: string = 'controlCenterDB';
  tabelaFornecedores: string = 'Fornecedores_Karrara_Transport';
  queryDiretasExtras: string = "Viagens-Diretas-Extras";
  data: any;
  base: number = 3;
  ID: number = Date.now();
  local: string = "";
  contato: string = "";
  endereco: string = "";
  comentario: string = "";
  dialogRef: any;
  items: any[] = [];
  totalMR: any[] = [];
  totalMRSemArg: any[] = [];
  itemsSP: any[] = [];
  itemsSul: any[] = [];
  itemsArg: any[] = [];
  itemsDiretosExtra: any[] = [];
  itemsInterplantas: any[] = [];
  itemsInterplantasNaoFinalizados: any[] = [];
  itemsSPFinalizados: any[] = [];
  itemsSulFinalizados: any[] = [];
  itemsArgNaoFinalizados: any[] = [];
  totalMRFinalizado: any[] = [];
  name!: string;
  dialogOpen = false;
  dialogTiposOpen = false;
  carrier!: any[];
  veiculos!: any[];
  teste!: boolean;
  startDate!: string;
  endDate!: string;
  milkRunSP: boolean = true;
  milkRunSul: boolean = true;
  milkRunArg: boolean = true;
  filteredItems!: any[];
  interplantas: any[] = [];
  filteredInterplantas: any[] = [];
  naoTerminadas: any[] = [];
  distanciaTotal: number = 0;
  pesoTotal: number = 0;
  pesoTotalInterplantas: number = 0;
  usuarioLogado!: UsuarioLogado;
  isCarrierTCMEnabled: boolean = true;
  isCarrierJSLEnabled: boolean = true;
  isCarrierJSLVWEnabled: boolean = true;
  isCarrierLOTSEnabled: boolean = true;
  isCarrierJSLARGEnabled: boolean = true;
  isCarrierEnabled: boolean = true;
  subscription: Subscription | undefined;
  hoje = new Date();
  dataFiltra2Dias!: string;
  dataFiltraInterplantas!: string;
  dataFiltraSul!: string;
  dataFiltraArg!: string;
  objFillingRate: number = 85;
  classFillingRate: string = "";
  objVeiculosGrandes: number = 90;
  classVeiculosGrandes: string = "";
  objJanelas: number = 90;
  classJanelas: string = "";
  objMR!: number;
  classMR: string = "";
  objInterplantas!: number;
  classInterplantas: string = "";
  viagensInterplantasFinalizadas!: any[];
  localNumber!: number;
  propertyName!: string;
  viagensInterplantasTerminadas!: any[];
  viagensInterplantasTerminadasNumero!: number;
  pesoTotalTransportadoMR!: number;
  valorTotalTransportadoMR: number = 0;
  totalCostMR!: number;
  MRtotalizado!: number;
  qtdVeiculosGD!: number;
  totalEmissao!: number;
  tolerancia: number = 0.1; // 10%
  eficiencia!: number;
  porcentagemPontual!: number;
  porcentagemAtrasado!: number;
  porcentagemTotal!: number;
  classJanelasPontual!: string;
  classJanelasAtrasada!: string;
  classJanelasTotal!: string;
  totalMRDeveriaFinalizar!: number;
  totalJanelasInterplantasObj!: number;
  searchText: string = 'All';
  viagensInterplantasNaoTerminadas!: any[];
  filterColumnDados: string = 'dataPainel';
  filterColumnOperacao: string = 'Janela';
  referenceDate!: string;
  numDays: number = 2;
  numDays5: number = 5;
  porcentagemPontualColeta!: number;
  porcentagemPontualEntrega!: number;
  porcentagemColetaPontual!: number;
  porcentagemColetaAtrasado!: number;
  porcentagemColetaTotal!: number;
  porcentagemEntregaPontual!: number;
  porcentagemEntregaAtrasado!: number;
  porcentagemEntregaTotal!: number;
  classJanelasColeta!: string;
  classJanelasEntrega!: string;
  valorUmColeta!: number;
  valorDoisColeta!: number;
  valorUmEntrega!: number;
  valorDoisEntrega!: number;
  totalJanelasValidasColeta!: number;
  totalJanelasValidasEntrega!: number;
  altura: number = 10;
  largura: number = 10;
  labels = ["02:00", "Realizadas", "Planejadas"];
  sortColumn: string = '';
  mergedData: any[] = []; // Definir explicitamente o tipo como any[]
  sortDirection: number = 1;
  R27: boolean = true;
  R16: boolean = false;
  R3: boolean = false;
  R26: boolean = false;
  R4: boolean = false;
  R40: boolean = true;
  R54: boolean = false;
  E56: boolean = false;
  E37: boolean = false;
  R56: boolean = true;
  R43: boolean = false;
  R22: boolean = false;
  timeTableExcesso: any[] = [];
  corJanela: string = '';
  atrasado: boolean = false;
  editMode = false;
  editedValue: any;
  filterColumn: string = 'date';
  filterColumnReservas: string = 'dataJanela';
  editJanelaDestino1!: string;
  editJanelaDestino2!: string;
  editJanelaDestino3!: string;
  editJanelaDestino4!: string;
  itemSelecionado: any;
  dataExibirPre: Date = new Date();
  dataExibir: Date = new Date();
  [key: string]: any;


  timeTable00 = this.createPlacaData();
  timeTable01 = this.createPlacaData();
  timeTable02 = this.createPlacaData();
  timeTable03 = this.createPlacaData();
  timeTable04 = this.createPlacaData();
  timeTable05 = this.createPlacaData();
  timeTable06 = this.createPlacaData();
  timeTable07 = this.createPlacaData();
  timeTable08 = this.createPlacaData();
  timeTable09 = this.createPlacaData();
  timeTable10 = this.createPlacaData();
  timeTable11 = this.createPlacaData();
  timeTable12 = this.createPlacaData();
  timeTable13 = this.createPlacaData();
  timeTable14 = this.createPlacaData();
  timeTable15 = this.createPlacaData();
  timeTable16 = this.createPlacaData();
  timeTable17 = this.createPlacaData();
  timeTable18 = this.createPlacaData();
  timeTable19 = this.createPlacaData();
  timeTable20 = this.createPlacaData();
  timeTable21 = this.createPlacaData();
  timeTable22 = this.createPlacaData();
  timeTable23 = this.createPlacaData();
  timeTable24 = this.createPlacaData();

  timeTableGeral: { [key: string]: any[] }[] = [this.timeTable00, this.timeTable01, this.timeTable02, this.timeTable03, this.timeTable04, this.timeTable05,
  this.timeTable06, this.timeTable07, this.timeTable08, this.timeTable09, this.timeTable10, this.timeTable11, this.timeTable12, this.timeTable13, this.timeTable14, this.timeTable15
    , this.timeTable16, this.timeTable17, this.timeTable18, this.timeTable19, this.timeTable20, this.timeTable21, this.timeTable22, this.timeTable23, this.timeTable24];


  itemsVW!: any[];
  itemsVWNaoFinalizados!: any[];
  isLoading: boolean = false;
  itemsSPFinalizados2!: any[];
  janelaDestino: any;
  fornecedores!: any[];
  numDays15: number = 10;
  edit2: boolean = false;
  totalReservas!: any[];
  itemsReserva!: any[];
  classHora!: any[];
  totalItensJetta!: any[];
  totalReservasREC!: any[];
  totalReservasSPEED!: any[];
  totalReservasR27!: any[];
  totalReservasR16!: any[];
  totalReservasR3!: any[];
  totalReservasR26!: any[];
  totalReservasR4!: any[];
  totalReservasR40!: any[];
  totalReservasR54!: any[];
  totalReservasE56!: any[];
  totalReservasE37!: any[];
  totalReservasR56!: any[];
  totalReservasR43!: any[];
  totalReservasR22!: any[];
  itemsChegadaLCB!: any[];
  objetosCorrespondentes!: any[];
  itemsContainers!: any[];
  atrasadoContainer: boolean = false;
  atrasadoSpeed: boolean = false;
  totalReservasEMB!: any[];
  atrasadoEMB!: boolean;
  itemsContainersReuse!: any[];
  itemsMRColetaEmbalagem!: any[];
  totalReservasEXP!: any[];
  atrasadoEXP!: boolean;
  volumesTotais: any;
  // volumesTotais!: {'EMB':number, 'EXP':number, 'SPEED':number, 'INT':number, 'REC':number }
  valorItemVolume: number[][] = new Array(25).fill([]).map(() => new Array(14).fill(0));
  itemsContainersPrev!: any[];
  array1Filtrado: any;
  array2Filtrado: any;
  itemsChegadaSCANIA!: any[];
  locaisColeta!: any[];
  locationsPoints: string[] = ['R27', 'R16', 'R3', 'R26', 'R4', 'R40', 'R54', 'E56', 'E37', 'R56', 'R43', 'R22', 'R29', 'R19', 'R99']

  constructor(
    public dialog: MatDialog,
    private dynamodbService: ApiService,
    private http: HttpClient, private cdr: ChangeDetectorRef,
    private servicoAutenticacao: AutenticacaoService,
    private router: Router,
    private datePipe: DatePipe
  ) {
    this.volumesTotais = {};
    this.itemsMRColetaEmbalagem = [];
  }

  async ngOnInit(): Promise<void> {
    this.isLoading = true;

    try {
      const today = new Date();
      const year = today.getFullYear();
      const month = (today.getMonth() + 1).toString().padStart(2, '0');
      const day = today.getDate().toString().padStart(2, '0');
      this.endDate = `${year}-${month}-${day}`;
      this.startDate = `${year}-${month}-${day}`;

      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() - 10);
      const sevenDaysAgoYear = sevenDaysAgo.getFullYear();
      const sevenDaysAgoMonth = (sevenDaysAgo.getMonth() + 1).toString().padStart(2, '0');
      const sevenDaysAgoDay = sevenDaysAgo.getDate().toString().padStart(2, '0');
      this.dataFiltraArg = `${sevenDaysAgoYear}-${sevenDaysAgoMonth}-${sevenDaysAgoDay}`;

      const twoDaysAgo = new Date(today);
      twoDaysAgo.setDate(today.getDate() - 1);
      const twoDaysAgoYear = twoDaysAgo.getFullYear();
      const twoDaysAgoMonth = (twoDaysAgo.getMonth() + 1).toString().padStart(2, '0');
      const twoDaysAgoDay = twoDaysAgo.getDate().toString().padStart(2, '0');
      this.dataFiltra2Dias = `${twoDaysAgoYear}-${twoDaysAgoMonth}-${twoDaysAgoDay}`;

      const threeDaysAgo = new Date(today);
      threeDaysAgo.setDate(today.getDate() - 3);
      const threeDaysAgoYear = threeDaysAgo.getFullYear();
      const threeDaysAgoMonth = (threeDaysAgo.getMonth() + 1).toString().padStart(2, '0');
      const threeDaysAgoDay = threeDaysAgo.getDate().toString().padStart(2, '0');
      this.dataFiltraSul = `${threeDaysAgoYear}-${threeDaysAgoMonth}-${threeDaysAgoDay}`;

      const diaAtual = new Date(today);
      diaAtual.setDate(today.getDate());
      const diaAtualYear = diaAtual.getFullYear();
      const diaAtualMonth = (diaAtual.getMonth() + 1).toString().padStart(2, '0');
      const diaAtualDay = diaAtual.getDate().toString().padStart(2, '0');
      this.dataFiltraInterplantas = `${diaAtualYear}-${diaAtualMonth}-${diaAtualDay}`;

      await this.getCarriersFromDynamoDB();
      await this.getUserLogado();
      await this.update();
      this.centerDialog();
      this.subscription = interval(3 * 60 * 1000).subscribe(async () => {
        await this.update();
      });
      this.isLoading = false;
    } catch (error) {
      console.error('Erro durante a execução do ngOnInit:', error);
    }
    // this.controleExcesso();
  }

  async update() {
    await this.getFornecedoresFromDynamoDB();
    await this.getItemsContainer();
    await this.getItemsFromArgentina();
    await this.getItemsFromDynamoDB();
    await this.getItemsFromJanelasReservadas();
    await this.getItemsFromVW();
    await this.getProgramacaoInterplantasFromDynamoDB();
    this.locationsPoints.forEach(local => {
      // console.log(local)
      for (let i = 0; i < 25; i++) {
        this.timeTableGeral[i][local] = []
      }
    })
    await this.somarFluxosFinalizado();
    // await this.verificaCorJanela();
    if (this.itemsContainers) {
      await this.atualizaStatus(this.itemsContainers);
    }
    if (this.totalReservasR27) {
      await this.atualizaStatus(this.totalReservasR27);
    }
    if (this.totalReservasR16) {
      await this.atualizaStatus(this.totalReservasR16);
    }
    if (this.totalReservasR3) {
      await this.atualizaStatus(this.totalReservasR3);
    }
    if (this.totalReservasR26) {
      await this.atualizaStatus(this.totalReservasR26);
    }
    if (this.totalReservasR4) {
      await this.atualizaStatus(this.totalReservasR4);
    }
    if (this.totalReservasR40) {
      await this.atualizaStatus(this.totalReservasR40);
    }
    if (this.totalReservasR54) {
      await this.atualizaStatus(this.totalReservasR54);
    }
    if (this.totalReservasE56) {
      await this.atualizaStatus(this.totalReservasE56);
    }
    if (this.totalReservasE37) {
      await this.atualizaStatus(this.totalReservasE37);
    }
    if (this.totalReservasR56) {
      await this.atualizaStatus(this.totalReservasR56);
    }
    if (this.totalReservasR43) {
      await this.atualizaStatus(this.totalReservasR43);
    }
    if (this.totalMR) {
      await this.atualizaStatus(this.totalMR);
    }
    if (this.itemsInterplantas) {
      await this.atualizaStatus(this.itemsInterplantas);
    }
    // await this.verificaCorJanela();
    await this.somarVolumes();
    await this.ordenarJanelas('R27');
    await this.ordenarJanelas('R16');
    await this.ordenarJanelas('R3');
    await this.ordenarJanelas('R26');
    await this.ordenarJanelas('R4');
    await this.ordenarJanelas('R40');
    await this.ordenarJanelas('R54');
    await this.ordenarJanelas('E56');
    await this.ordenarJanelas('E37');
    await this.ordenarJanelas('R56');
    await this.ordenarJanelas('R43');
    await this.ordenarJanelas('R22');
    await this.ordenarJanelas('R19');

    await this.controleExcesso();
  }

  async atualizaData() {
    this.isLoading = true;
    this.dataExibir = this.dataExibirPre;
    let novaDataExibir = new Date(this.dataExibir);
    // Adicionar 3 horas à nova data
    novaDataExibir.setHours(novaDataExibir.getHours() + 3);
    // Atualizar this.dataExibir para a nova data
    this.dataExibir = novaDataExibir;
    await this.update();
    this.isLoading = false;
  }

  createPlacaData(): { [key: string]: any[] } {
    return {
      // REC: [],
      // EMB: [],
      // EXP: [],
      // INT: [],
      // SPEED: [],

      R27: [],
      R16: [],
      R3: [],
      R26: [],
      R4: [],
      R40: [],
      R54: [],
      E56: [],
      E37: [],
      R56: [],
      R43: [],
      R22: [],
      R19: []
    };
  }

  isDateValid(dateString: string) {
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  }

  async atualizaStatus(items: any[]) {
    let dataChegadaString = '';
    let dataEntradaString = '';
    let dataSaidaString = '';
    let dataString = '';

    try {
      await items.forEach(async item => {
        let chegou = false;
        let entrou = false;
        let saiu = false;
        // this.itemsContainers.forEach(item => {
        // console.log(item.ID)
        // console.log(item.Plate)
        // // console.log(item.saida)
        // console.log(item.ChegadaLCB)
        // console.log(item.EntradaLCB)
        // console.log(item)

        if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('SCANIA') && item['JanelaDestino 1']) {
          dataString = item['JanelaDestino 1'];
        } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('SCANIA') && item['JanelaDestino 2']) {
          dataString = item['JanelaDestino 2'];
        } else if (item['Janela']) {
          dataString = item['Janela'].toString();
        } else if (item.dataJanelaTimeTable) {
          dataString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000Z`;
        }
        if (item['chegada']) {
          dataChegadaString = item['chegada'];
        } else if (item['ChegadaSCANIA']) {
          dataChegadaString = item['ChegadaSCANIA'];
        } else {
          dataChegadaString = "0001-01-01T00:00:00";
        }
        // dataChegadaString = item['chegada'] ? item['chegada'] : "0001-01-01T00:00:00";
        try{
        if (dataString.includes("Z")) {
          dataString = dataString.replace("Z", "");
        }
      }catch{
        console.log(item)
        console.log(dataString)
      }
        if (item['entrada']) {
          dataEntradaString = item['entrada'];
        } else if (item['EntradaSCANIA']) {
          dataEntradaString = item['EntradaSCANIA'];
        } else {
          dataEntradaString = "0001-01-01T00:00:00";
        }
        if (item['saida']) {
          dataSaidaString = item['saida'];
        } else if (item['SaidaSCANIA']) {
          dataSaidaString = item['SaidaSCANIA'];
        } else {
          dataSaidaString = "0001-01-01T00:00:00";
        }

        if (dataChegadaString.includes("Z")) {
          dataChegadaString = dataChegadaString.replace("Z", "");
        }
        if (dataEntradaString.includes("Z")) {
          dataEntradaString = dataEntradaString.replace("Z", "");
        }
        if (dataSaidaString.includes("Z")) {
          dataSaidaString = dataSaidaString.replace("Z", "");
        }

        const dataJanela = new Date(dataString);
        const dataChegada = new Date(dataChegadaString);
        const dataEntrada = new Date(dataEntradaString);
        const dataSaida = new Date(dataSaidaString);
        const dataAtual = new Date();
        const dataZero = new Date("0001-01-01T00:00:00");
        const dataUndefined = new Date("0001-01-01T00:00:00");

        // console.log(dataChegadaString);
        // console.log(dataEntradaString);
        // console.log(dataSaidaString);
        // console.log(new Date(dataSaidaString));
        // console.log(dataSaida.getTime());
        // console.log(dataZero.getTime());

        if ((dataChegada.getTime() != dataZero.getTime()) && (dataChegada.getTime() != dataUndefined.getTime())) {
          chegou = true;
        }
        if ((dataEntrada.getTime() != dataZero.getTime()) && (dataEntrada.getTime() != dataUndefined.getTime())) {
          entrou = true;
        }
        if ((dataSaida.getTime() != dataZero.getTime()) && (dataSaida.getTime() != dataUndefined.getTime())) {
          saiu = true;
        }

        // console.log(dataZero.getTime());
        // // console.log(dataJanela);
        // // console.log(dataAtual);
        // console.log("chegou " + chegou);
        // console.log(dataChegada.getTime());
        // console.log("entrou " + entrou);
        // console.log(dataEntrada.getTime());
        // console.log("saiu " + saiu);
        // console.log(dataSaida.getTime());
        // console.log('item.prioridade');
        // console.log(item.prioridade);

        if (dataJanela > dataAtual && !chegou) {
          item.statusEntrega = 'emTempo';
          if (item.prioridade) {
            item.statusEntrega = 'priorizadoEmTempo';
          }
        }
        if (dataJanela > dataAtual && chegou) {
          if (saiu) {
            item.statusEntrega = 'finalizadoEmTempo';
          } else if (entrou) {
            item.statusEntrega = 'chegouEntrouEmTempo';
          } else if (!entrou) {
            item.statusEntrega = 'chegouNaoEntrouEmTempo';
            if (item.prioridade) {
              item.statusEntrega = 'priorizadoChegouNaoEntrouEmTempo';
            }
          }
        }
        if (dataJanela < dataAtual && !chegou) {
          item.statusEntrega = 'atrasado';
          if (item.prioridade) {
            item.statusEntrega = 'priorizadoAtrasado';
          }
        }
        if (dataJanela < dataAtual && chegou) {
          if (dataJanela < dataChegada) {
            if (saiu) {
              item.statusEntrega = 'finalizadoAtrasado';
            } else if (entrou) {
              item.statusEntrega = 'chegouEntrouAtrasado';
            } else if (!entrou) {
              item.statusEntrega = 'chegouNaoEntrouAtrasado';
              if (item.prioridade) {
                item.statusEntrega = 'priorizadoChegouNaoEntrouAtrasado';
              }
            }
          } else {
            if (saiu) {
              item.statusEntrega = 'finalizadoEmTempo';
            } else if (entrou) {
              item.statusEntrega = 'chegouEntrouEmTempo';
            } else if (!entrou) {
              item.statusEntrega = 'chegouNaoEntrouEmTempo';
              if (item.prioridade) {
                item.statusEntrega = 'priorizadoChegouNaoEntrouEmTempo';
              }
            }
          }
        }
        if (item.FinalizadaManual) {
          // console.log("esta com finalizada manual")
          item.statusEntrega = 'finalizadaManual';
        }
      })
    } catch {
      console.log("error no atualizaStatus");
      // console.log(items);
    }
  }

  async findLocationByName(name: string, locations: any[]): Promise<Location[]> {
    let localArray;
    // console.log(name)
    // console.log(locations)
    if (name == "LCB") {
      name = "LCB DEMARCHI"
    }
    let local = await locations.find((location: { local: string; }) => location.local === name);
    if (local === undefined) {
      console.log("Fornecedor não cadastrado !")
      console.log(name);
    }
    // console.log(local)
    if (local !== undefined) {
      try {
        localArray = local.localDescarga.includes('/') ? local.localDescarga.split('/').map((s: string) => s.trim()) : [local.localDescarga.trim()];
      } catch {
        // console.log(local.localDescarga)
        localArray = ['R99'];
      }
    }
    return localArray;
  }

  hasIntersection(array1: any[], array2: any[]): boolean {
    // Retorna `true` se houver qualquer item em comum entre os arrays
    return array1.some(item => array2.includes(item));
  }

  mergeWithoutDuplicates(...arrays: any[][]): any[] {
    // Junta todos os arrays, filtra valores undefined e depois usa Set para remover duplicados
    const mergedArray = new Set(arrays.flat().filter(item => item !== undefined));
    return Array.from(mergedArray);
  }

  async somarFluxosFinalizado() {
    this.totalMR = []
    this.totalMR = this.totalMR.concat(this.itemsArg);
    this.totalMR = this.totalMR.concat(this.totalItensJetta);
    this.totalMR = this.totalMR.concat(this.itemsVW);
    this.totalMR.forEach(item => {
      try {
        item.Transportadora = item.description.includes('JSL') ? 'JSL' : item.description.includes('TCM') ? 'TCM' : item.description.includes('SESE') ? 'SESE' : item.description.includes('LOTS') ? 'LOTS' : item.description.includes('ARG') ? 'JSL-ARG' : 'Outros'
        item.Fornecedores = (item['Fornecedor 1'] ? item['Fornecedor 1'] : '') + (item['Fornecedor 2'] ? ', ' + item['Fornecedor 2'] : '') + (item['Fornecedor 3'] ? ', ' + item['Fornecedor 3'] : '') + (item['Fornecedor 4'] ? ', ' + item['Fornecedor 4'] : '')
      } catch {
      }
    })
    if (this.totalMR.length > 1) {
      // console.log(this.totalMR)
      this.totalMR.forEach(async (item, index) => {
        // if (item.Plate == 'RUI9D25') {
        //   console.log(item)
        if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('SCANIA')) {
          try {
            if (item.locations !== undefined) {
              // console.log('destino 1 entrou if location1')
              item.locations.forEach(async (local: any, index: number) => {
                let date1str = item["JanelaDestino 1"].replace("Z", "");
                let janela = new Date(date1str)
                janela.setHours(janela.getHours() + index);
                await this.ajusteTimeTable(item, local, janela.toString());
              })
            }
          } catch {
            // console.log(item)
          }
        }
        if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('SCANIA') && item['Destino 2'] != item['Destino 1']) {
          if (item.locations !== undefined) {
            // console.log('destino 2 entrou if location1')
            item.locations.forEach(async (local: any, index: number) => {
              let date1str = item["JanelaDestino 2"].replace("Z", "");
              let janela = new Date(date1str)
              janela.setHours(janela.getHours() + index);
              await this.ajusteTimeTable(item, local, janela.toString());
            })
          }
        }
        if (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('SCANIA') && item['Destino 3'] != item['Destino 1'] && item['Destino 3'] != item['Destino 2']) {
          if (item.locations !== undefined) {
            // console.log('destino 3 entrou if location1')
            item.locations.forEach(async (local: any, index: number) => {
              let date1str = item["JanelaDestino 3"].replace("Z", "");
              let janela = new Date(date1str)
              janela.setHours(janela.getHours() + index);
              await this.ajusteTimeTable(item, local, janela.toString());
            })
          }
        }
      })
    }

    this.locationsPoints.forEach(point => {
      try {
        if (this['totalReservas' + point] !== undefined) {
          this['totalReservas' + point].forEach(async (item: any) => {
            // console.log("entrou")
            // if(point == 'R27'){
            // console.log('totalReservas' + point)
            let dataHoraString;
            if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('SCANIA') && item['JanelaDestino 1']) {
              dataHoraString = item['JanelaDestino 1'];
            }
            else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('SCANIA') && item['JanelaDestino 2']) {
              dataHoraString = item['JanelaDestino 2'];
            }
            else if (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('SCANIA') && item['JanelaDestino 3']) {
              dataHoraString = item['JanelaDestino 3'];
            }
            else {
              dataHoraString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000Z`;
            }
            if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('SCANIA') && item.locations.includes(point)) {
              // console.log("entrou dest1")
              await this.ajusteTimeTable(item, point, dataHoraString);
            } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('SCANIA') && item.locations.includes(point)) {
              // console.log("entrou dest2")
              await this.ajusteTimeTable(item, point, dataHoraString);
            } else if (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('SCANIA') && item.locations.includes(point)) {
              // console.log("entrou dest3")
              await this.ajusteTimeTable(item, point, dataHoraString);
            }
            // }
          })
        }
      } catch {
        console.log("error no somarFluxosFinalizado");
        // console.log(this['totalReservas' + point])
      }
    });

    if (this.itemsContainers.length > 1) {
      // console.log(this.itemsContainers)
      this.itemsContainers.forEach(async (item, index) => {
        item['JanelaDestino 1'] = item["Janela"]
        item['Destino 1'] = item.destino
        await this.ajusteTimeTable(item, 'E56', item["Janela"], item.destino);
      })
    }

    this.itemsInterplantas.forEach(async (item) => {
      if (item.Local == 'R19') {
        item.Local = 'R26'
      }
      item.locations = item.Local;
      await this.ajusteTimeTable(item, item.Local, item['Janela'])
    })

  }

  ordenarJanelas(area: string) {
    for (let i = 0; i < 24; i++) {
      this.timeTableGeral[i][area] = this.timeTableGeral[i][area].sort((a, b) => {
        // Colocar os itens priorizados primeiro
        if (a.prioridade && !b.prioridade) {
          return -1; // `a` vem antes de `b`
        } else if (!a.prioridade && b.prioridade) {
          return 1; // `b` vem antes de `a`
        }
        // Se ambos têm ou nenhum tem prioridade, continuar com a ordenação por data
        let dataA = a.created;
        let dataB = b.created;
        if (a.lastUpdate) {
          dataA = a.lastUpdate;
        }
        if (b.lastUpdate) {
          dataB = b.lastUpdate;
        }
        const normalizeDate = (date: string) => {
          if (!isNaN(Number(date))) {
            return new Date(Number(date));
          }
          return new Date(date);
        };
        const dateA = normalizeDate(dataA);
        const dateB = normalizeDate(dataB);
        return dateA.getTime() - dateB.getTime();
      });
    }
  }

  somarVolumes() {
    // const areas = ['REC', 'SPEED', 'EXP', 'INT', 'EMB'];
    const areas = this.locationsPoints;
    // Zerar os valores de this.valorItemVolume
    for (let i = 0; i < this.valorItemVolume.length; i++) {
      for (let j = 0; j < areas.length; j++) {
        this.valorItemVolume[i][j] = 0;
      }
    }
    // Objeto para armazenar os volumes totais para cada área
    const volumesTotaisPorArea: { [key: string]: number[] } = {};
    // Inicializar o array para armazenar os valores de volume por item e por área
    // Iterar sobre cada área
    areas.forEach((area, i) => {
      // console.log(area);      
      // Inicializar o array de volumes totais para a área atual
      volumesTotaisPorArea[area] = [];
      // Iterar sobre cada item da área atual
      this.timeTableGeral.forEach((item, index) => {
        // console.log(item);          
        item[area].forEach(subItem => {
          // console.log(subItem);
          const volumesComoNumero = parseFloat(subItem.Volumes);
          if (!isNaN(volumesComoNumero)) {
            this.valorItemVolume[index][i] += volumesComoNumero;
            // Adicionar o volume do subItem ao array de volumes totais para a área atual
            volumesTotaisPorArea[area].push(volumesComoNumero);
          }
        });
      });
    });
    // console.log(this.valorItemVolume);
  }

  isISODateValid(dateString: string) {
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  }

  controleExcesso() {
    this.timeTableExcesso = [];
    this.classHora = [];  // Adicionando uma assinatura de índice
    for (let i = 0; i < 25; i++) {
      if (this.timeTableGeral[i]['R27'].length > 4) {
        const startIndex = 4;
        const endIndex = this.timeTableGeral[i]['R27'].length;
        this.classHora[i] = "semClasse";
        for (let j = startIndex; j < endIndex; j++) {
          if (this.timeTableGeral[i]['R27'][j]) {
            const item = this.timeTableGeral[i]['R27'][j];
            // console.log(item.Plate)
            item.area = 'R27';
            this.timeTableExcesso.push(item);
            this.classHora[i] = "red-background";
          }
        }
      }
      if (this.timeTableGeral[i]['R16'].length > 1) {
        const startIndex = 1;
        const endIndex = this.timeTableGeral[i]['R16'].length;
        this.classHora[i] = "semClasse";
        for (let j = startIndex; j < endIndex; j++) {
          if (this.timeTableGeral[i]['R16'][j]) {
            const item = this.timeTableGeral[i]['R16'][j];
            // console.log(item.Plate)
            item.area = 'R16';
            this.timeTableExcesso.push(item);
            this.classHora[i] = "red-background";
          }
        }
      }
      if (this.timeTableGeral[i]['R3'].length > 2) {
        const startIndex = 2;
        const endIndex = this.timeTableGeral[i]['R3'].length;
        this.classHora[i] = "semClasse";
        for (let j = startIndex; j < endIndex; j++) {
          if (this.timeTableGeral[i]['R3'][j]) {
            const item = this.timeTableGeral[i]['R3'][j];
            // console.log(item.Plate)
            item.area = 'R3';
            this.timeTableExcesso.push(item);
            this.classHora[i] = "red-background";
          }
        }
      }
      if (this.timeTableGeral[i]['R26'].length > 1) {
        const startIndex = 1;
        const endIndex = this.timeTableGeral[i]['R26'].length;
        this.classHora[i] = "semClasse";
        for (let j = startIndex; j < endIndex; j++) {
          if (this.timeTableGeral[i]['R26'][j]) {
            const item = this.timeTableGeral[i]['R26'][j];
            // console.log(item.Plate)
            item.area = 'R26';
            this.timeTableExcesso.push(item);
            this.classHora[i] = "red-background";
          }
        }
      }
      if (this.timeTableGeral[i]['R4'].length > 1) {
        const startIndex = 1;
        const endIndex = this.timeTableGeral[i]['R4'].length;
        this.classHora[i] = "semClasse";
        for (let j = startIndex; j < endIndex; j++) {
          if (this.timeTableGeral[i]['R4'][j]) {
            const item = this.timeTableGeral[i]['R4'][j];
            // console.log(item.Plate)
            item.area = 'R4';
            this.timeTableExcesso.push(item);
            this.classHora[i] = "red-background";
          }
        }
      }
      if (this.timeTableGeral[i]['R40'].length > 2) {
        const startIndex = 2;
        const endIndex = this.timeTableGeral[i]['R40'].length;
        this.classHora[i] = "semClasse";
        for (let j = startIndex; j < endIndex; j++) {
          if (this.timeTableGeral[i]['R40'][j]) {
            const item = this.timeTableGeral[i]['R40'][j];
            // console.log(item.Plate)
            item.area = 'R40';
            this.timeTableExcesso.push(item);
            this.classHora[i] = "red-background";
          }
        }
      }
      if (this.timeTableGeral[i]['R54'].length > 2) {
        const startIndex = 2;
        const endIndex = this.timeTableGeral[i]['R54'].length;
        this.classHora[i] = "semClasse";
        for (let j = startIndex; j < endIndex; j++) {
          if (this.timeTableGeral[i]['R54'][j]) {
            const item = this.timeTableGeral[i]['R54'][j];
            // console.log(item.Plate)
            item.area = 'R54';
            this.timeTableExcesso.push(item);
            this.classHora[i] = "red-background";
          }
        }
      }
      if (this.timeTableGeral[i]['E56'].length > 4) {
        const startIndex = 4;
        const endIndex = this.timeTableGeral[i]['E56'].length;
        this.classHora[i] = "semClasse";
        for (let j = startIndex; j < endIndex; j++) {
          if (this.timeTableGeral[i]['E56'][j]) {
            const item = this.timeTableGeral[i]['E56'][j];
            // console.log(item.Plate)
            item.area = 'E56';
            this.timeTableExcesso.push(item);
            this.classHora[i] = "red-background";
          }
        }
      }
      if (this.timeTableGeral[i]['E37'].length > 4) {
        const startIndex = 4;
        const endIndex = this.timeTableGeral[i]['E37'].length;
        this.classHora[i] = "semClasse";
        for (let j = startIndex; j < endIndex; j++) {
          if (this.timeTableGeral[i]['E37'][j]) {
            const item = this.timeTableGeral[i]['E37'][j];
            // console.log(item.Plate)
            item.area = 'E37';
            this.timeTableExcesso.push(item);
            this.classHora[i] = "red-background";
          }
        }
      }
      if (this.timeTableGeral[i]['R56'].length > 2) {
        const startIndex = 2;
        const endIndex = this.timeTableGeral[i]['R56'].length;
        this.classHora[i] = "semClasse";
        for (let j = startIndex; j < endIndex; j++) {
          if (this.timeTableGeral[i]['R56'][j]) {
            const item = this.timeTableGeral[i]['R56'][j];
            // console.log(item.Plate)
            item.area = 'R56';
            this.timeTableExcesso.push(item);
            this.classHora[i] = "red-background";
          }
        }
      }
      if (this.timeTableGeral[i]['R43'].length > 1) {
        const startIndex = 1;
        const endIndex = this.timeTableGeral[i]['R43'].length;
        this.classHora[i] = "semClasse";
        for (let j = startIndex; j < endIndex; j++) {
          if (this.timeTableGeral[i]['R43'][j]) {
            const item = this.timeTableGeral[i]['R43'][j];
            // console.log(item.Plate)
            item.area = 'R43';
            this.timeTableExcesso.push(item);
            this.classHora[i] = "red-background";
          }
        }
      }
      if (this.timeTableGeral[i]['R22'].length > 2) {
        const startIndex = 2;
        const endIndex = this.timeTableGeral[i]['R22'].length;
        this.classHora[i] = "semClasse";
        for (let j = startIndex; j < endIndex; j++) {
          if (this.timeTableGeral[i]['R22'][j]) {
            const item = this.timeTableGeral[i]['R22'][j];
            // console.log(item.Plate)
            item.area = 'R22';
            this.timeTableExcesso.push(item);
            this.classHora[i] = "red-background";
          }
        }
      }
      if (this.timeTableGeral[i]['R99'].length > 0) {
        const startIndex = 0;
        const endIndex = this.timeTableGeral[i]['R99'].length;
        this.classHora[i] = "semClasse";
        for (let j = startIndex; j < endIndex; j++) {
          if (this.timeTableGeral[i]['R99'][j]) {
            const item = this.timeTableGeral[i]['R99'][j];
            // console.log(item.Plate)
            item.area = ['R99'];
            this.timeTableExcesso.push(item);
            this.classHora[i] = "red-background";
          }
        }
      }
    }
    try {
      this.timeTableExcesso.forEach(async item => {
        try {
          item.Janela = item.Janela && this.isValidDate(item.Janela) ? item.Janela : item["Destino 1"].toUpperCase().includes('SCANIA') ? item["JanelaDestino 1"] : item["JanelaDestino 2"]
        }
        catch {
          console.log(item)
        }
        try {
          if (item.description?.includes("JSL")) {
            item.Transportadora = "JSL"
          }
          else if (item.description?.includes("TCM")) {
            item.Transportadora = "TCM"
          }
          else if (item.description?.includes("ARG")) {
            item.Transportadora = "JSL"
          }
          else if (item.Transportadora) {
            item.Transportadora = item.Transportadora
          }
          else {
            item.Transportadora = ""
          }
          item.Janela = this.formatarData(item.Janela);
        } catch (error) {
          item.Janela = item.Janela.toString();
          item.Janela = this.formatarData(item.Janela);
          // console.log(typeof item.Janela)
          // console.log(item)
        }
      })
    } catch {
      console.log("Erro na construção da time table excesso")
    }
    // console.log(this.timeTableExcesso)
  }

  async ajusteTimeTable(item: any, area: any, janela: string, destino?: string): Promise<void> {
    // console.log(area)
    // console.log(janela)
    return new Promise<void>((resolve) => {
      let date1str;
      // areaArray.forEach(area => {
      if (area == 'R27') {
        // date1str = item["Janela"].replace("Z", "");
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      } else if (area == 'R16') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      } else if (area == 'R3') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      } else if (area == 'R26') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      } else if (area == 'R4') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      } else if (area == 'R40') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      } else if (area == 'R54') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      } else if (area == 'E56') {
        // console.log('passou por aqui')
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      } else if (area == 'E37') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      } else if (area == 'R56') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      } else if (area == 'R43') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      } else if (area == 'R22') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      }
      else {
        date1str = new Date();
      }
      const date1 = new Date(date1str);
      const horaAtual = new Date();
      const ehJanelaEspecial = horaAtual.getHours() === 0; // entre 00:00 e 00:59
      const dataExibirAtual = new Date(this.dataExibir);
      dataExibirAtual.setHours(0, 0, 0, 0);
      const diaAnterior = new Date(dataExibirAtual);
      diaAnterior.setDate(dataExibirAtual.getDate() - 1);
      const proximoDia = new Date(dataExibirAtual);
      proximoDia.setDate(dataExibirAtual.getDate() + 1);
      const inicioJanelaEspecialAnterior = new Date(diaAnterior);
      inicioJanelaEspecialAnterior.setHours(23, 6, 0, 0); // 00:00 do dia exibido
      const fimJanelaEspecialAnterior = new Date(dataExibirAtual);
      fimJanelaEspecialAnterior.setHours(0, 5, 59, 999); // 00:05 do dia exibido
      const inicioJanelaEspecialProxima = new Date(dataExibirAtual);
      inicioJanelaEspecialProxima.setHours(23, 6, 0, 0); // 00:00 do dia exibido
      const fimJanelaEspecialProxima = new Date(proximoDia);
      fimJanelaEspecialProxima.setHours(0, 5, 59, 999); // 00:05 do dia exibido
      // Verifica se a viagem está na janela especial da virada anterior
      const JanelaDaViradaProxima = date1 >= inicioJanelaEspecialProxima && date1 <= fimJanelaEspecialProxima;
      const JanelaDaViradaAnterior = date1 >= inicioJanelaEspecialAnterior && date1 <= fimJanelaEspecialAnterior;

      // console.log('***********   INICIO   *************')
      // console.log(item.ID)
      // console.log('janela', date1str)
      // console.log('this.dataExibir', this.dataExibir)
      // console.log('************************')
      // console.log('date1', date1)
      // console.log('inicioJanelaEspecialProxima', inicioJanelaEspecialProxima)
      // console.log('fimJanelaEspecialProxima', fimJanelaEspecialProxima)
      // console.log('JanelaDaViradaProxima', JanelaDaViradaProxima)
      // console.log('************************')
      // console.log('inicioJanelaEspecialAnterior', inicioJanelaEspecialAnterior)
      // console.log('fimJanelaEspecialAnterior', fimJanelaEspecialAnterior)
      // console.log('JanelaDaViradaAnterior', JanelaDaViradaAnterior)
      // console.log('************************')
      // console.log('this.dataExibir.toDateString()', this.dataExibir.toDateString())
      // console.log('date1.toDateString()', date1.toDateString())
      // console.log('***********  FIM   *************')

      // if (!JanelaDaViradaProxima && !JanelaDaViradaAnterior ) {
      if ((this.dataExibir.toDateString() !== date1.toDateString() && !JanelaDaViradaAnterior) ||
        (this.dataExibir.toDateString() == date1.toDateString() && JanelaDaViradaProxima)) {
        return resolve(); // Fora da janela especial e não é do mesmo dia
      }

      const horaDoDia = date1.getHours();
      const minutos = date1.getMinutes();
      // console.log(horaDoDia)
      // console.log(minutos)
      let periodoDoDia;
      switch (true) {
        case (horaDoDia == 0 && minutos > 5) || (horaDoDia == 1 && minutos <= 5):
          periodoDoDia = "01:00 - 02:00";
          this.timeTableGeral[1][area].push(item)
          break;
        case (horaDoDia == 1 && minutos > 5) || (horaDoDia == 2 && minutos <= 5):
          periodoDoDia = "02:00 - 03:00";
          this.timeTableGeral[2][area].push(item)
          break;
        case (horaDoDia == 2 && minutos > 5) || (horaDoDia == 3 && minutos <= 5):
          periodoDoDia = "03:00 - 04:00";
          this.timeTableGeral[3][area].push(item)
          break;
        case (horaDoDia == 3 && minutos > 5) || (horaDoDia == 4 && minutos <= 5):
          periodoDoDia = "04:00 - 05:00";
          this.timeTableGeral[4][area].push(item)
          break;
        case (horaDoDia == 4 && minutos > 5) || (horaDoDia == 5 && minutos <= 5):
          periodoDoDia = "05:00 - 06:00";
          this.timeTableGeral[5][area].push(item)
          break;
        case (horaDoDia == 5 && minutos > 5) || (horaDoDia == 6 && minutos <= 5):
          periodoDoDia = "06:00 - 07:00";
          this.timeTableGeral[6][area].push(item)
          break;
        case (horaDoDia == 6 && minutos > 5) || (horaDoDia == 7 && minutos <= 5):
          periodoDoDia = "07:00 - 08:00";
          this.timeTableGeral[7][area].push(item)
          // console.log(item)
          // console.log(this.timeTableGeral[7][area])
          break;
        case (horaDoDia == 7 && minutos > 5) || (horaDoDia == 8 && minutos <= 5):
          periodoDoDia = "08:00 - 09:00";
          try {
            this.timeTableGeral[8][area].push(item)
          }
          catch {
            console.log(item)
          }
          break;
        case (horaDoDia == 8 && minutos > 5) || (horaDoDia == 9 && minutos <= 5):
          periodoDoDia = "09:00 - 10:00";
          try {
            this.timeTableGeral[9][area].push(item)
            // console.log("deu certo")
            // console.log(item)
          } catch {
            console.log("ERRO")
            console.log(item)
          }
          break;
        case (horaDoDia == 9 && minutos > 5) || (horaDoDia == 10 && minutos <= 5):
          periodoDoDia = "10:00 - 11:00";
          try {
            this.timeTableGeral[10][area].push(item)
            // console.log("deu certo")
            // console.log(item)
          } catch {
            console.log("ERRO")
            console.log(item)
          }
          break;
        case (horaDoDia == 10 && minutos > 5) || (horaDoDia == 11 && minutos <= 5):
          periodoDoDia = "11:00 - 12:00";
          try {
            this.timeTableGeral[11][area].push(item)
          } catch {
            console.log(item)
          }
          break;
        case (horaDoDia == 11 && minutos > 5) || (horaDoDia == 12 && minutos <= 5):
          periodoDoDia = "12:00 - 13:00";
          try {
            this.timeTableGeral[12][area].push(item)
          } catch {
            console.log(item)
          }
          break;
        case (horaDoDia == 12 && minutos > 5) || (horaDoDia == 13 && minutos <= 5):
          periodoDoDia = "13:00 - 14:00";
          try {
            this.timeTableGeral[13][area].push(item)
          } catch {
            console.log(item)
          }
          break;
        case (horaDoDia == 13 && minutos > 5) || (horaDoDia == 14 && minutos <= 5):
          periodoDoDia = "14:00 - 15:00";
          try {
            this.timeTableGeral[14][area].push(item)
          } catch {
            console.log(item)
          }
          break;
        case (horaDoDia == 14 && minutos > 5) || (horaDoDia == 15 && minutos <= 5):
          periodoDoDia = "15:00 - 16:00";
          try {
            this.timeTableGeral[15][area].push(item)
          } catch {
            console.log(item)
          }
          break;
        case (horaDoDia == 15 && minutos > 5) || (horaDoDia == 16 && minutos <= 5):
          periodoDoDia = "16:00 - 17:00";
          try {
            this.timeTableGeral[16][area].push(item)
          } catch {
            // console.log(item)
          }
          break;
        case (horaDoDia == 16 && minutos > 5) || (horaDoDia == 17 && minutos <= 5):
          periodoDoDia = "17:00 - 18:00";
          try {
            this.timeTableGeral[17][area].push(item)
          } catch { }
          break;
        case (horaDoDia == 17 && minutos > 5) || (horaDoDia == 18 && minutos <= 5):
          periodoDoDia = "18:00 - 19:00";
          this.timeTableGeral[18][area].push(item)
          break;
        case (horaDoDia == 18 && minutos > 5) || (horaDoDia == 19 && minutos <= 5):
          periodoDoDia = "19:00 - 20:00";
          this.timeTableGeral[19][area].push(item)
          break;
        case (horaDoDia == 19 && minutos > 5) || (horaDoDia == 20 && minutos <= 5):
          periodoDoDia = "20:00 - 21:00";
          this.timeTableGeral[20][area].push(item)
          break;
        case (horaDoDia == 20 && minutos > 5) || (horaDoDia == 21 && minutos <= 5):
          periodoDoDia = "21:00 - 22:00";
          this.timeTableGeral[21][area].push(item)
          break;
        case (horaDoDia == 21 && minutos > 5) || (horaDoDia == 22 && minutos <= 5):
          periodoDoDia = "22:00 - 23:00";
          this.timeTableGeral[22][area].push(item)
          break;
        case (horaDoDia == 22 && minutos > 5) || (horaDoDia == 23 && minutos <= 5):
          periodoDoDia = "23:00 - 24:00";
          this.timeTableGeral[23][area].push(item)
          break;
        case (horaDoDia == 23 && minutos > 5) || (horaDoDia == 24):
          periodoDoDia = "00:00 - 01:00";
          this.timeTableGeral[0][area].push(item)
          console.log(item)
          break;
        default:
          periodoDoDia = "Outro período do dia";
      }
      // this.timeTableGeral.forEach(id => {
      //   this.locationsPoints.forEach(async point => {
      //     if (id[point].length >= 1) {
      //       console.log(id[point].length)
      //       console.log(point)
      //       console.log(id[point])
      //     }
      //   })
      // })
      // this.timeTableGeral[7]['R27'].forEach(item => {
      //   console.log(item)
      // })
      resolve();
      // });
    });
  }

  compareDates(date1str: string, date2str: string): number {
    let dateSTRsemZ = date1str.replace("Z", "");
    let dateSTR2semZ = date2str.replace("Z", "");
    const date1 = new Date(dateSTRsemZ);
    const date2 = new Date(dateSTR2semZ);
    const timestamp1 = date1.getTime();
    const timestamp2 = date2.getTime();
    // //console.log(date1)
    // //console.log(date2)
    if (timestamp1 < timestamp2) {
      return -1; // date1 é anterior a date2
    } else if (timestamp1 > timestamp2) {
      return 1; // date1 é posterior a date2
    } else {
      return 0; // date1 é igual a date2
    }
  }

  compareDates2(date1str: string, date2str: string): number {
    const date1 = new Date(date1str);
    const date2 = new Date(date2str);
    const timestamp1 = date1.getTime();
    const timestamp2 = date2.getTime();
    // //console.log(date1)
    // //console.log(date2)
    if (timestamp1 < timestamp2) {
      return -1; // date1 é anterior a date2
    } else if (timestamp1 > timestamp2) {
      return 1; // date1 é posterior a date2
    } else {
      return 0; // date1 é igual a date2
    }
  }

  isValorValido(value: any): boolean {
    // const data = this.isDateValid(value);
    return value !== '' && value !== null && value !== undefined;
  }

  getFormattedDate(i: number, dataExibir: Date): string {
    const date = new Date(dataExibir); // Cria uma cópia da data original
    if (i === 24) {
      date.setDate(date.getDate() + 1); // Adiciona 1 dia
      return `${date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })} 00`; // 'dd/MM 00'
    }
    return `${i.toString().padStart(2, '0')}`; // Retorna 'dd/MM/yyyy HH'
  }

  editDialog(item: any): void {
    console.log(item)
    const companyUsuarioLogado = this.usuarioLogado.company?.toLowerCase();
    const transportadoraItem = item.Transportadora ? item.Transportadora.toLowerCase() : 'NA';
    // console.log(item.Transportadora)
    // console.log(this.usuarioLogado.company)
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && transportadoraItem.includes(companyUsuarioLogado))) {
      // console.log("edit 1")
      this.item = { ...item };
      // console.log(item)
      // console.log(item.forn1)
      // console.log(item.jan1)
      // console.log(item.Plate)
      // console.log(item.Volumes)
      if (item.description && item.description?.includes("JSL")) {
        this.item.transportadora = "JSL"
      }
      else if (item.description && item.description?.includes("TCM")) {
        this.item.transportadora = "TCM"
      }
      else if (item.description && item.description?.includes("ARG")) {
        this.item.transportadora = "JSL"
      }
      else if (item.Transportadora) {
        this.item.transportadora = item.Transportadora
      }
      else {
        this.item.transportadora = "Sem registro"
      }
      // this.item.Plate = item.Plate
      // this.item.Volumes = item.Volumes
      // this.item.idContainer = item.idContainer
      this.item.forn1 = (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('SCANIA')) ? item["Destino 1"] : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('SCANIA')) ? item["Destino 2"] :
        (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('SCANIA')) ? item["Destino 3"] : (item["destino"] && item["destino"].toUpperCase().includes('SCANIA')) ? item["destino"] : item.forn1
      this.item.jan1 = (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('SCANIA') && item["JanelaDestino 1"]) ? item["JanelaDestino 1"] : 
        (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('SCANIA') && item["JanelaDestino 2"]) ? item["JanelaDestino 2"] :
        (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('SCANIA') && item["JanelaDestino 3"]) ? item["JanelaDestino 3"] : 
        (item["destino"] && item["destino"].toUpperCase().includes('SCANIA') && item["Janela"] ) ? item["Janela"] : 
        this.item.Janela ? this.item.Janela : 
        this.item.dataJanelaTimeTable ? `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000Z` :
        this.item.jan1
      this.item.destinoIndex = (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('SCANIA')) ? "Destino 1" : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('SCANIA')) ? "Destino 2" :
        (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('SCANIA')) ? "Destino 3" : "semIndex"
      this.item.janelaIndex = (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('SCANIA')) ? "JanelaDestino 1" : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('SCANIA')) ? "JanelaDestino 2" :
        (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('SCANIA')) ? "JanelaDestino 3" : "semIndex"
      const dataHoraString = this.item.jan1;
      // Extrair a data e a hora da string
      const dataString = dataHoraString.slice(0, 10); // "2024-04-23"
      const horaString = dataHoraString.slice(11, 16); // "00:00"
      // console.log(dataString); // Saída: 2024-04-23
      // console.log(horaString); // Saída: 00:00
      this.item.dataJanela = dataString;
      this.item.horaJanela = horaString;
      // this.item.tableName = item.tableName;
      // this.item.ID = item.ID
      this.dialogOpen = true;
      // console.log(this.item)
    } else {
      const confirmacao = window.confirm("Usuário não autorizado!");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.dialogOpen = false;
      }
    }
  }

  editDialog2(area: string): void {
    const companyUsuarioLogado = this.usuarioLogado.company?.toLowerCase();
    // console.log(this.usuarioLogado.company)
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || this.usuarioLogado.role == '5' || (this.usuarioLogado.role == '3' && area == 'REC')) {
      // console.log("edit 2");
      this.edit2 = true;
      this.item = [];
      this.item.Plate = "";
      this.item.Transportadora = "";
      this.item.Volumes = "";
      this.item.idContainer = "";
      this.item.forn1 = "SCANIA";
      this.item['Destino 1'] = "SCANIA";
      this.item.dataJanela = "";
      this.item.horaJanela = "";
      this.item.jan1 = "";
      this.item['JanelaDestino 1'] = '';
      this.item.destinoIndex = 'Destino 1';
      this.item.janelaIndex = 'JanelaDestino 1';
      this.item.area = area;
      this.item.locations = area;
      const currentDate = new Date().getTime();
      // const year = currentDate.getFullYear();
      // const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
      // const day = currentDate.getDate().toString().padStart(2, '0');
      // const hours = currentDate.getHours().toString().padStart(2, '0');
      // const minutes = currentDate.getMinutes().toString().padStart(2, '0');
      // const seconds = currentDate.getSeconds().toString().padStart(2, '0');
      // // Formata a data e hora no formato ISO desejado (sem considerar o fuso horário)
      // const isoDateString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000Z`;
      this.item.created = currentDate.toString();
      const id = new Date().getTime();
      // console.log(id.toString())
      this.item.ID = id.toString();
      this.item.tableName = this.queryTimeTable;
      // console.log(this.item)
      this.dialogOpen = true;
    } else {
      const confirmacao = window.confirm("Usuário não autorizado!");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.dialogOpen = false;
      }
    }
  }

  async reservaEmbalagem(item: any) {
    this.isLoading = true;
    this.dialogOpen = false;
    const currentDate = new Date().getTime();
    let janelaStr = '';
    let destino = '';
    let janela = new Date();
    if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('SCANIA')) {
      destino = item["Destino 1"];
      janelaStr = item["JanelaDestino 1"];
      janela = new Date(janelaStr)
    } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('SCANIA')) {
      destino = item["Destino 2"];
      janelaStr = item["JanelaDestino 2"];
      janela = new Date(janelaStr)
    } else if (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('SCANIA')) {
      destino = item["Destino 3"];
      janelaStr = item["JanelaDestino 3"];
      janela = new Date(janelaStr)
    }
    janela.setHours(janela.getHours() + 1);
    // this.totalItensJetta.forEach(item => {
    //   if (item.coletaEmbalagem) {
    // Verifica se já existe um item com o mesmo ID
    const exists = this.totalReservasEMB.some((existingItem: { ID: any; }) => existingItem.ID === item.ID);
    // Se não existir, adiciona o item
    if (!exists) {
      this.item = item;
      this.item["Destino 1"] = destino;
      this.item["JanelaDestino 1"] = janela;
      this.item.area = "EMB";
      this.item.tableName = this.queryTimeTable;
      this.item.created = currentDate.toString();
      const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
      const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
      // Converter a string JSON para um objeto JavaScript
      const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
      // Converter o objeto JavaScript de volta para uma string JSON
      const modifiedJsonString = JSON.stringify(jsonObject);
      // Converter a string JSON para um objeto JavaScript
      const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
      // Criar um array contendo o objeto
      const jsonArray = [jsonObject2];
      // console.log(jsonArray)
      await this.dynamodbService.salvar(jsonArray, this.queryTimeTable, this.urlAtualiza).subscribe(async response => {
        // console.log(response)
        await this.update();
        this.edit2 = false;
        this.dialogOpen = false;
        this.isLoading = false;
      }, error => {
        console.log(error);
      });
      // this.itemsMRColetaEmbalagem.push(item);
    }
    else {
      this.dialogOpen = false;
      this.isLoading = false;
    }
    // }
    // });
  }

  async reutilizarEXP(item: any) {
    this.isLoading = true;
    this.dialogOpen = false;
    const currentDate = new Date().getTime();
    let janelaStr = '';
    let destino = '';
    let janela = new Date();
    if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('SCANIA')) {
      destino = item["Destino 1"];
      janelaStr = item["JanelaDestino 1"];
      janela = new Date(janelaStr)
    } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('SCANIA')) {
      destino = item["Destino 2"];
      janelaStr = item["JanelaDestino 2"];
      janela = new Date(janelaStr)
    } else if (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('SCANIA')) {
      destino = item["Destino 3"];
      janelaStr = item["JanelaDestino 3"];
      janela = new Date(janelaStr)
    }
    janela.setHours(janela.getHours() + 1);
    // this.totalItensJetta.forEach(item => {
    //   if (item.coletaEmbalagem) {
    // Verifica se já existe um item com o mesmo ID
    const exists = this.totalReservasEXP.some((existingItem: { ID: any; }) => existingItem.ID === item.ID);
    // Se não existir, adiciona o item
    if (!exists) {
      this.item = item;
      this.item["Destino 1"] = destino;
      this.item["JanelaDestino 1"] = janela;
      this.item.area = "EXP";
      this.item.tableName = this.queryTimeTable;
      this.item.created = currentDate.toString();
      const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
      const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
      // Converter a string JSON para um objeto JavaScript
      const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
      // Converter o objeto JavaScript de volta para uma string JSON
      const modifiedJsonString = JSON.stringify(jsonObject);
      // Converter a string JSON para um objeto JavaScript
      const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
      // Criar um array contendo o objeto
      const jsonArray = [jsonObject2];
      // console.log(jsonArray)
      await this.dynamodbService.salvar(jsonArray, this.queryTimeTable, this.urlAtualiza).subscribe(async response => {
        // console.log(response)
        await this.update();
        this.edit2 = false;
        this.dialogOpen = false;
        this.isLoading = false;
      }, error => {
        console.log(error);
      });
      // this.itemsMRColetaEmbalagem.push(item);
    }
    else {
      this.dialogOpen = false;
      this.isLoading = false;
    }
    // }
    // });
  }

  async salvar() {
    if (this.item.idContainer && this.item.idContainer != "") {
      this.item.ID = this.item.idContainer;
    }
    // console.log(this.item.ID)
    // console.log(this.item.dataJanela)
    // console.log(this.item.horaJanela)
    const dataHoraString = `${this.item.dataJanela}T${this.item.horaJanela}:00.000Z`;
    // console.log(dataHoraString)
    const dataHora = new Date(dataHoraString);
    // console.log(dataHora)
    if (this.edit2 = false) {
      dataHora.setHours(dataHora.getHours() - 3);
    }
    const formattedDate = dataHora.toISOString();
    // console.log(formattedDate);
    this.isLoading = true;
    this.item[this.item['janelaIndex']] = formattedDate,
      this.item = {
        ...this.item,
        // "ID": this.item.ID,
        'lastUpdate': new Date(),
        'userLogado': this.usuarioLogado.id,
        'UpdateByUser' : this.usuarioLogado.id,
        "dataJanela": this.item.dataJanela,
        "date": this.item.dataJanela,
        // "horaJanela": this.item.horaJanela,      
        // this.item['JanelaDestino 1'] = formattedDate,
        // ['janelaIndex']: formattedDate,
        'Janela': formattedDate,
        'jan1': formattedDate
        // "Plate": this.item.Plate,
        // "Volumes": this.item.Volumes,
        // "idContainer": this.item.idContainer,
        // "Transportadora": this.item.transportadora,
        // 'Fornecedor 1': this.item['Fornecedor 1'] ? this.item['Fornecedor 1'] : "Fornecedor não informado",
        // 'Fornecedores': this.item['Fornecedor 1'] ? this.item['Fornecedor 1'] : "Fornecedor não informado",
        // // "forn1": this.item.forn1,
        // "tableName": this.item.tableName ? this.item.tableName : this.queryTimeTable,
        // // "jan1": this.item.jan1,
        // [this.item.destinoIndex]: this.item.forn1
      }
    // }
    // this.item.tableName = this.queryTimeTable
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    // console.log(this.item)
    await this.dynamodbService.salvar(jsonArray, this.queryTimeTable, this.urlAtualiza).subscribe(async response => {
      // console.log(response)
      await this.update();
      this.edit2 = false;
      this.dialogOpen = false;
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
  }

  formatarData(data: string): string {
    if (data) {
      const date1str = data.replace("Z", "");
      const dataObj = new Date(date1str)
      const dataFormatada = `${dataObj.toLocaleDateString('pt-BR')} ${dataObj.toLocaleTimeString('pt-BR')}`;
      return dataFormatada;
    } else {
      return 'sem data';
    }
  }

  convertToISOFormat(dateString: string): string | null {
    // Expressão regular para verificar o formato dd/MM/yyyy HH:mm:ss
    const dateTimeRegex = /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/;
    if (!dateString.match(dateTimeRegex)) {
      return null; // Retorna null se a string não estiver no formato esperado
    }
    // Extrai os componentes da data e hora da string
    const [datePart, timePart] = dateString.split(' ');
    const [day, month, year] = datePart.split('/').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);
    // Cria um objeto Date com os componentes extraídos (mês é zero-indexado)
    const dateObject = new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));
    // Converte para formato ISO 8601
    const isoString = dateObject.toISOString();
    return isoString;
  }

  centerDialog(): void {
    const dialogRefElement = this.dialogRef?.containerInstance?.hostElement;
    if (dialogRefElement) {
      const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const dialogWidth = dialogRefElement.clientWidth;
      const dialogHeight = dialogRefElement.clientHeight;
      const top = Math.max(0, (windowHeight - dialogHeight) / 2);
      const left = Math.max(0, (windowWidth - dialogWidth) / 2);
      dialogRefElement.style.top = `${top}px`;
      dialogRefElement.style.left = `${left}px`;
    }
  }

  isValidDate(dateStr: string) {
    const date = new Date(dateStr);
    return !isNaN(date.getTime());
  }

  async getItemsContainer(): Promise<void> {
    const today = new Date();
    // this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    this.referenceDate = this.convertTimestampToFormattedDate(this.dataExibir.getTime());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos("Container_exportacao", this.urlConsultaCompactada, 'All', "Janela", this.referenceDate, this.numDays5)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          ////console.log(items)
          if (Array.isArray(items)) {
            this.itemsContainersPrev = items
            this.itemsContainers = this.filtrarItens(this.itemsContainersPrev);
            this.itemsContainers.forEach(async item => {
              item.location1 = 'E56';
            });
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  formatarDataChegada(data: string): string {
    // Verifica se a data está no primeiro formato (MM/DD/YYYY HH:mm:ss AM/PM)
    if (/^\d{1,2}\/\d{1,2}\/\d{4} \d{1,2}:\d{2}:\d{2} (AM|PM)$/.test(data)) {
      // Separa os componentes da data
      const partes = data.split(/[\s/:]/);
      // Converte para o formato desejado (DD/MM/YYYY HH:mm:ss)
      const novaData = `${partes[1]}/${partes[0]}/${partes[2]} ${partes[3]}:${partes[4]}:${partes[5]}`;
      return novaData;
    }
    // Se estiver no segundo formato ou em outro formato, retorna a data original
    return data;
  }

  converterStringParaData(dataString: string): Date | null {
    dataString = this.formatarDataChegada(dataString);
    // Divide a string de data em partes separadas
    const partes = dataString.split(/[\/\s:]/);
    // Verifica se há 6 partes (ano, mês, dia, hora, minuto, segundo)
    if (partes.length === 6) {
      // Obtém os componentes individuais da data
      const ano = parseInt(partes[2], 10);
      const mes = parseInt(partes[1], 10) - 1; // Os meses em JavaScript são baseados em zero (janeiro é 0)
      const dia = parseInt(partes[0], 10);
      const hora = parseInt(partes[3], 10);
      const minuto = parseInt(partes[4], 10);
      const segundo = parseInt(partes[5], 10);
      // Cria um objeto Date com os componentes da data
      const data = new Date(ano, mes, dia, hora, minuto, segundo);
      return data;
    } else {
      // Se o formato da string de data não estiver correto, retorne null
      return null;
    }
  }

  async getItemsFromDynamoDB(): Promise<void> {
    const today = new Date();
    let local1: any[] = [];
    let local2: any[] = [];
    let local3: any[] = [];
    let local4: any[] = [];
    // this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    this.referenceDate = this.convertTimestampToFormattedDate(this.dataExibir.getTime());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(this.query, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, this.numDays5)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.items = items
            // console.log(items)
            this.totalItensJetta = this.filtrarItens(this.items);
            this.totalItensJetta.forEach(async item => {
              if (item['Fornecedor 1']) {
                local1 = item.location1 ? item.location1.includes('/') ? item.location1.split('/').map((s: string) => s.trim()) : [item.location1[0].trim()] : await this.findLocationByName(item['Fornecedor 1'], this.locaisColeta);
                // console.log(item.location1)
              }
              if (item['Fornecedor 2']) {
                local2 = item.location2 ? item.location2.includes('/') ? item.location2.split('/').map((s: string) => s.trim()) : [item.location2[0].trim()] : await this.findLocationByName(item['Fornecedor 2'], this.locaisColeta);
              }
              if (item['Fornecedor 3']) {
                local3 = item.location3 ? item.location3.includes('/') ? item.location3.split('/').map((s: string) => s.trim()) : [item.location3[0].trim()] : await this.findLocationByName(item['Fornecedor 3'], this.locaisColeta);
              }
              if (item['Fornecedor 4']) {
                local4 = item.location4 ? item.location4.includes('/') ? item.location4.split('/').map((s: string) => s.trim()) : [item.location4[0].trim()] : await this.findLocationByName(item['Fornecedor 4'], this.locaisColeta);
              }
              item.locations = this.mergeWithoutDuplicates(local1, local2, local3, local4);
            })
            // console.log(this.totalItensJetta)
            this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getItemsFromJanelasReservadas(): Promise<void> {
    const today = new Date();
    this.referenceDate = this.convertTimestampToFormattedDate(this.dataExibir.getTime());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(this.queryTimeTable, this.urlConsultaCompactada, 'All', this.filterColumnReservas, this.referenceDate, this.numDays)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = await JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.itemsReserva = items;
            // console.log(this.itemsReserva)
            this.totalReservas = this.filtrarItens(this.itemsReserva);
            // console.log(this.totalReservas)
            this.totalReservas.forEach(async item => {
              item.locations = item.area//await this.findLocationByName(item['Fornecedor 1'], this.locaisColeta);
            })

            this.totalReservasR27 = []
            this.totalReservasR27 = this.totalReservas.filter(item => {
              // console.log(item.area)
              return (item.area == 'R27');
            })

            this.totalReservasR16 = []
            this.totalReservasR16 = this.totalReservas.filter(item => {
              return (item.area == 'R16');
            })

            this.totalReservasR3 = []
            this.totalReservasR3 = this.totalReservas.filter(item => {
              return (item.area == 'R3');
            })

            this.totalReservasR26 = []
            this.totalReservasR26 = this.totalReservas.filter(item => {
              return (item.area == 'R26');
            })

            this.totalReservasR4 = []
            this.totalReservasR4 = this.totalReservas.filter(item => {
              return (item.area == 'R4');
            })

            this.totalReservasR40 = []
            this.totalReservasR40 = this.totalReservas.filter(item => {
              return (item.area == 'R40');
            })

            this.totalReservasR54 = []
            this.totalReservasR54 = this.totalReservas.filter(item => {
              return (item.area == 'R54');
            })

            this.totalReservasE56 = []
            this.totalReservasE56 = this.totalReservas.filter(item => {
              return (item.area == 'E56');
            })

            this.totalReservasE37 = []
            this.totalReservasE37 = this.totalReservas.filter(item => {
              return (item.area == 'E37');
            })

            this.totalReservasR56 = []
            this.totalReservasR56 = this.totalReservas.filter(item => {
              return (item.area == 'R56');
            })

            this.totalReservasR43 = []
            this.totalReservasR43 = this.totalReservas.filter(item => {
              return (item.area == 'R43');
            })
            this.totalReservasR22 = []
            this.totalReservasR22 = this.totalReservas.filter(item => {
              return (item.area == 'R22');
            })
            // console.log(this.totalReservasR27)
            this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  compararDatas(data1: string, data2: string) {
    // console.log(data1)
    // console.log(data2)
    const dataFormatada1 = new Date(data1).toLocaleDateString();
    const dataFormatada2 = new Date(data2).toLocaleDateString();
    // console.log(dataFormatada1)
    // console.log(dataFormatada2)
    return dataFormatada1 === dataFormatada2;
  }

  compararSubstrings(string1: string, string2: string, comprimentoMinimo: number) {
    // Converte ambas as strings para minúsculas para fazer uma comparação sem diferenciação entre maiúsculas e minúsculas
    // console.log(string1)
    // console.log(string2)
    const substrings1 = string1.toLowerCase().split(/\s+/); // Divida por espaços
    const substrings2 = string2.toLowerCase().split(/\s+/); // Divida por espaços

    // Filtra substrings com menos de comprimentoMinimo caracteres
    const substringsFiltradas1 = substrings1.filter(substring => substring.length > comprimentoMinimo);
    const substringsFiltradas2 = substrings2.filter(substring => substring.length > comprimentoMinimo);

    // Verifica se há alguma substring comum
    const temSubstringsComuns = substringsFiltradas1.some(substring1 =>
      substringsFiltradas2.some(substring2 => substring1.includes(substring2) || substring2.includes(substring1))
    );
    return temSubstringsComuns;
  }

  filtrarItens(itens: any[]): any[] {
    let destinoSCANIA2 = false;
    let date1str;
    this.dataExibir.setHours(0, 0, 0, 0); // Define as horas para 00:00:00
    // console.log(this.dataExibir)
    return itens.filter(item => {
      if (item['Destino 1']) {
        if (item['Destino 1'].toUpperCase().includes('SCANIA')) {
          destinoSCANIA2 = item['Destino 1'] && item['Destino 1'].toUpperCase().includes('SCANIA');
          if (item['JanelaDestino 1']) {
            date1str = item['JanelaDestino 1'].replace("Z", "");
          }
          else {
            date1str = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000Z`;
          }
          // let date1str = item['JanelaDestino 1'].replace("Z", "");
          const dataJanelaDestino = new Date(date1str);
          dataJanelaDestino.setHours(0, 0, 0, 0);
          // console.log(item.ID)
          // console.log(item['Destino 1'])
          // console.log(item['Destino 1'].toUpperCase().includes('SCANIA'))
          // console.log(this.dataExibir.getTime())
          // console.log(dataJanelaDestino.getTime())
          // console.log(this.dataExibir)
          // console.log(dataJanelaDestino)
          return dataJanelaDestino.getTime() === this.dataExibir.getTime();
        } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('SCANIA')) {
          destinoSCANIA2 = item['Destino 2'] && item['Destino 2'].toUpperCase().includes('SCANIA');
          let date2str = item['JanelaDestino 2'].replace("Z", "");
          const dataJanelaDestino = new Date(date2str);
          // Defina as horas da data da propriedade "JanelaDestino 2" para 00:00:00
          dataJanelaDestino.setHours(0, 0, 0, 0);
          // Verifica se a data é igual ao dia atual
          return dataJanelaDestino.getTime() === this.dataExibir.getTime();
        }
        else {
          return false; // Se "Destino 2" não contém "SCANIA", o item não é incluído
        }
      } else {
        if (item['Janela']) {
          destinoSCANIA2 = item['destino'] && item['destino'].toUpperCase().includes('SCANIA');
          // console.log(item['Janela'])
          let date2str = item['Janela'].replace("Z", "");
          const dataJanelaDestino = new Date(date2str);
          // console.log(dataJanelaDestino)
          // Defina as horas da data da propriedade "JanelaDestino 2" para 00:00:00
          dataJanelaDestino.setHours(0, 0, 0, 0);
          // Verifica se a data é igual ao dia atual
          return dataJanelaDestino.getTime() === this.dataExibir.getTime();
        }
        else {
          return false; // Se "Destino 2" não contém "SCANIA", o item não é incluído
        }
      }
    });
  }

  async compareDatesSemHoras(date1str: string, date2str: string): Promise<number> {
    // date1str = date1str.replace("Z", "");
    // console.log(date1str)
    // console.log(date2str)
    if (date1str !== undefined) {
      try {
        // await this.retiraeZ(date1str); //= date1str.replace("Z", "");
        date1str = date1str.replace("Z", "");
        // date2str = date2str.replace("Z", "");
      } catch {
        // console.log(date1str)
      }
    }
    const date1 = this.removeTimeFromDate(new Date(date1str));
    const date2 = this.removeTimeFromDate(new Date(date2str));
    const timestamp1 = date1.getTime();
    const timestamp2 = date2.getTime();
    if (timestamp1 < timestamp2) {
      // console.log(date1)
      // console.log(date2)
      // console.log("retorno -1")
      return -1; // date1 é anterior a date2
    } else if (timestamp1 > timestamp2) {
      // console.log(date1)    
      // console.log(date2)
      // console.log("retorno 1")
      return 1; // date1 é posterior a date2
    } else {
      // console.log(date1)
      // console.log(date2)
      // console.log("retorno 0")
      return 0; // date1 é igual a date2
    }
  }

  removeTimeFromDate(date: Date): Date {
    date.setHours(0, 0, 0, 0);
    return date;
  }

  parseDateString(dateStr: string) {
    if (!dateStr.includes("T")) {
      dateStr += "T00:00:00";
    }
    return new Date(dateStr);
  }

  convertTimestampToFormattedDate(timestamp: number): string {
    // Converta para segundos dividindo por 1000
    const timestampSeconds = timestamp / 1000;
    // Crie um objeto Date
    const date = new Date(timestampSeconds * 1000); // Multiplique por 1000 para obter milissegundos
    // Formate a data no formato desejado
    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Use formato de 24 horas
    }).replace(',', ''); // Remova a vírgula
    return formattedDate;
  }

  async getProgramacaoInterplantasFromDynamoDB(): Promise<void> {
    // console.log("entrou no get ")
    this.totalJanelasInterplantasObj = 0;
    const currentDate = new Date();
    // this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    this.referenceDate = this.convertTimestampToFormattedDate(this.dataExibir.getTime());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(this.queryInterplantas, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, this.numDays)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          ////console.log(items)
          if (Array.isArray(items)) {
            this.viagensInterplantasFinalizadas = [];
            // console.log(items)
            this.itemsInterplantas = items
            this.viagensInterplantasFinalizadas = await items
              .filter(item =>
                item["Janela"] >= this.dataFiltraInterplantas && item.JanelaConcluida > 0)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getItemsFromArgentina(maxRetries: number = 3): Promise<void> {
    const today = new Date();
    // this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    this.referenceDate = this.convertTimestampToFormattedDate(this.dataExibir.getTime());
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const response: any = await new Promise(async (resolve, reject) => {
          (await this.dynamodbService.getItemsVolumesAltos(this.query4, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, this.numDays15)).subscribe(
            (res: any) => resolve(res),
            (error: any) => reject(error)
          );
        });
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.argentina = items;
              this.itemsArg = this.filtrarItens(this.argentina);
              this.itemsArg.forEach(async item => {
                if (item['Fornecedor 1']) {
                  item.location1 = item.location1 ? item.location1.includes('/') ? item.location1.split('/') : [item.location1] : await this.findLocationByName(item['Fornecedor 1'], this.locaisColeta);
                  // console.log(item.location1)
                }
                if (item['Fornecedor 2']) {
                  item.location2 = item.location2 ? item.location2.includes('/') ? item.location2.split('/') : [item.location2] : await this.findLocationByName(item['Fornecedor 2'], this.locaisColeta);
                }
                if (item['Fornecedor 3']) {
                  item.location3 = item.location3 ? item.location3.includes('/') ? item.location3.split('/') : [item.location3] : await this.findLocationByName(item['Fornecedor 3'], this.locaisColeta);
                }
                if (item['Fornecedor 4']) {
                  item.location4 = item.location4 ? item.location4.includes('/') ? item.location4.split('/') : [item.location4] : await this.findLocationByName(item['Fornecedor 4'], this.locaisColeta);
                }
              })
              return; // Saia da função se bem-sucedido
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      } catch (error) {
        console.error(`Attempt ${attempt} failed:`, error);
      }
      if (attempt < maxRetries) {
        // console.log(`Retrying... (${attempt}/${maxRetries})`);
      }
    }
    console.error('All attempts to fetch items from Argentina failed.');
  }

  // async getItemsFromDiretosExtra(maxRetries: number = 3): Promise<void> {
  //   const today = new Date();
  //   // this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
  //   this.referenceDate = this.convertTimestampToFormattedDate(this.dataExibir.getTime());
  //   for (let attempt = 1; attempt <= maxRetries; attempt++) {
  //     try {
  //       const response: any = await new Promise(async (resolve, reject) => {
  //         (await this.dynamodbService.getItemsVolumesAltos(this.queryDiretasExtras, this.urlConsultaCompactada, 'All', "dataSolicitacao", this.referenceDate, 3)).subscribe(
  //           (res: any) => resolve(res),
  //           (error: any) => reject(error)
  //         );
  //       });
  //       if (response.statusCode === 200) {
  //         try {
  //           const items = JSON.parse(response.body);
  //           if (Array.isArray(items)) {
  //             this.itemsDiretosExtra = items;
  //             console.log(this.itemsDiretosExtra)
  //             this.itemsDiretosExtra.forEach(async item => {
  //               if (item.localRecebimento == 'R29') {
  //                 item.localRecebimento = 'R27';
  //               }
  //             });
  //             return; // Saia da função se bem-sucedido
  //           } else {
  //             console.error('Invalid items data:', items);
  //           }
  //         } catch (error) {
  //           console.error('Error parsing JSON:', error);
  //         }
  //       } else {
  //         console.error('Invalid response:', response);
  //       }
  //     } catch (error) {
  //       console.error(`Attempt ${attempt} failed:`, error);
  //     }
  //     if (attempt < maxRetries) {
  //       // console.log(`Retrying... (${attempt}/${maxRetries})`);
  //     }
  //   }
  //   console.error('All attempts to fetch items from Argentina failed.');
  // }

  async getItemsFromVW(): Promise<void> {
    const today = new Date();
    // try {
    //   const response: any = await new Promise(async (resolve, reject) => {
    //     (await this.dynamodbService.getItems(this.queryVW, this.urlConsulta, 'All')).subscribe(
    //       (res: any) => resolve(res),
    //       (error: any) => reject(error)
    //     );
    //   });
    this.referenceDate = this.convertTimestampToFormattedDate(this.dataExibir.getTime());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(this.queryVW, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, 2)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });

      if (response.statusCode == 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            const auxItemsVW = items
            this.itemsVW = this.filtrarItens(auxItemsVW);
            this.itemsVW.forEach(async item => {
              if (item['Fornecedor 1']) {
                item.location1 = item.location1 ? item.location1.includes('/') ? item.location1.split('/') : [item.location1] : await this.findLocationByName(item['Fornecedor 1'], this.locaisColeta);
                // console.log(item.location1)
              }
              if (item['Fornecedor 2']) {
                item.location2 = item.location2 ? item.location2.includes('/') ? item.location2.split('/') : [item.location2] : await this.findLocationByName(item['Fornecedor 2'], this.locaisColeta);
              }
              if (item['Fornecedor 3']) {
                item.location3 = item.location3 ? item.location3.includes('/') ? item.location3.split('/') : [item.location3] : await this.findLocationByName(item['Fornecedor 3'], this.locaisColeta);
              }
              if (item['Fornecedor 4']) {
                item.location4 = item.location4 ? item.location4.includes('/') ? item.location4.split('/') : [item.location4] : await this.findLocationByName(item['Fornecedor 4'], this.locaisColeta);
              }
            });

          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getCarriersFromDynamoDB(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.query2, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.carrier = items.map(item => ({ ...item, checked: false }));
              // Adiciona a chave 'checked' a cada item, com valor inicial como false
              // Forçar detecção de alterações após atualizar os dados
              this.cdr.detectChanges();
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async getFornecedoresFromDynamoDB(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.tabelaFornecedores, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.locaisColeta = items.map(item => ({ ...item, checked: false }));
              // Adiciona a chave 'checked' a cada item, com valor inicial como false
              // Forçar detecção de alterações após atualizar os dados
              this.cdr.detectChanges();
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async deleteItemTabelaExtraScania(ID: string): Promise<void> {
    // const confirmacao = window.confirm("Tem certeza que deseja excluir este registro?");
    // if (confirmacao) {
    this.isLoading = true;
    await this.dynamodbService.deleteItem(ID, this.urlAtualiza, this.queryDiretasExtras).subscribe(
      async response => {
        console.log("Deletado da tabela de extra Scania")
      },
      error => {
        // Lógica para lidar com erros durante a deleção do item
      }
    );
    // }
  }

  async deleteItem(Item: any): Promise<void> {
    // const companyUsuarioLogado = this.usuarioLogado.company?.toLowerCase();
    // const transportadoraItem = Item.Transportadora.toLowerCase();
    // console.log(item.Transportadora)
    // console.log(this.usuarioLogado.company)
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {// || (this.usuarioLogado.role == '3' && transportadoraItem.includes(companyUsuarioLogado) && Item.area == "EMB")) {
      const confirmacao = window.confirm("Tem certeza que deseja excluir esta viagem?");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.isLoading = true;
        const ID = Item.ID;
        await this.dynamodbService.deleteItem(ID, this.urlAtualiza, Item.tableName).subscribe(
          async response => {
            if (Item.origemExtraScania) {
              await this.deleteItemTabelaExtraScania(Item.ID);
            }
            await this.ngOnInit();
            this.dialogOpen = false;
            this.isLoading = false;
          },
          error => {
            // Lógica para lidar com erros durante a deleção do item
          }
        );
      }
    } else {
      const confirmacao = window.confirm("Usuário não autorizado!");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.dialogOpen = false;
      }
    }
  }

  async FinalizarViagem(item: any) {
    const confirmacao = window.confirm("Tem certeza que deseja finalizar esta viagem?");
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      //console.log(item)
      var PassoF: any = []
      var PassoD: any = []
      for (let i = 1; i < 5; i++) {
        if (item['Fornecedor ' + i]) {
          PassoF[i] = 1;
        } else {
          PassoF[i] = 0;
        }
        // //console.log('PassoF[' + i + '] = ' + PassoF[i])
      }
      for (let i = 1; i < 5; i++) {
        if (item['Destino ' + i]) {
          PassoD[i] = 1;
        } else {
          PassoD[i] = 0;
        }
        // //console.log('PassoD[' + i + '] = ' + PassoD[i])
      }

      const body = [{
        ...item, // Mantém as chaves existentes
        "ID": item.ID,
        "FinalizadaManual": true,
        'Passo Fornecedor1': PassoF[1],
        'Passo Fornecedor2': PassoF[2],
        'Passo Fornecedor3': PassoF[3],
        'Passo Fornecedor4': PassoF[4],
        'Passo Destino1': PassoD[1],
        'Passo Destino2': PassoD[2],
        'Passo Destino3': PassoD[3],
        'Passo Destino4': PassoD[4],
      }];

      //nao usa a query, ele manda a time table no item
      await this.dynamodbService.salvar(body, item.tableName, this.urlAtualiza).subscribe(async response => {
        // Atualiza o item no banco de dados com sucesso
        await this.update();
        this.dialogOpen = false;
        this.isLoading = false;
      }, error => {
        console.log(error);
        // Lidar com o erro ao atualizar o item no banco de dados
      });
    }
  }


  sortBy(column: string) {
    if (this.sortColumn === column) {
      // Reverse the sort direction
      this.sortDirection *= -1;
    } else {
      // Set the new sort column and reset the sort direction
      this.sortColumn = column;
      this.sortDirection = 1;
    }

    // Sort the data array based on the selected column and direction
    this.mergedData.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const valueA = a[this.sortColumn];
      const valueB = b[this.sortColumn];

      if (valueA < valueB) {
        return -1 * this.sortDirection;
      } else if (valueA > valueB) {
        return 1 * this.sortDirection;
      } else {
        return 0;
      }
    });
  }

  cancel(): void {
    this.edit2 = false;
    this.dialogOpen = false;
  }

  async getUserLogado() {
    this.usuarioLogado = await this.servicoAutenticacao.obterUsuarioLogado()
    await this.enableFields();
    await this.enableFieldsTCM();
    await this.enableFieldsLOTS();
    await this.enableFieldsJSL();
    await this.enableFieldsJSLARG();
    await this.enableFieldsJSLVW();
  }

  navigateTo(route: string): void {
    this.router.navigateByUrl(route);
  }

  removeDuplicados(array1: any[], array2: any[]) {
    // Cria conjuntos dos IDs dos arrays
    const ids1 = new Set(array1.map(item => item.ID));
    const ids2 = new Set(array2.map(item => item.ID));
    // console.log(array1)
    // Encontra IDs duplicados
    const duplicados = new Set([...ids1].filter(id => ids2.has(id)));
    // console.log(duplicados)
    const arrayFiltrado = array1.filter(item => !duplicados.has(item.ID));
    // console.log(arrayFiltrado)
    return arrayFiltrado;
  }

  async exportToExcel(data: any[], area: string): Promise<void> {
    var columnOrder: any[] = [];
    // console.log(data);
    if (data.length === 0) {
      //console.log('Nenhum dado para exportar.');
      return;
    }
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {
      columnOrder = [
        'ID',
        'Plate',
        'Transport Type',
        'Transportadora',
        'Fornecedores',
        'Volumes',
        'Destino 1',
        'dataJanelaDestino1',
        'horaJanelaDestino1',
        'Destino 2',
        'dataJanelaDestino2',
        'horaJanelaDestino2',
        'data Chegada',
        'hora Chegada',
        'data Entrada',
        'hora Entrada',
        'data Entrada Doca',
        'hora Entrada Doca',
        'data Saida Doca',
        'hora Saida Doca',
        'Permanencia na Doca',
        'data Saida',
        'hora Saida',
        'statusEntrega',
        'FinalizadaManual',
      ];
    } else {
      columnOrder = [
        'ID',
        'Plate',
        'Transport Type',
        'Transportadora',
        'Fornecedores',
        'Volumes',
        'Destino 1',
        'dataJanelaDestino1',
        'horaJanelaDestino1',
        'Destino 2',
        'dataJanelaDestino2',
        'horaJanelaDestino2',
        'data Chegada',
        'hora Chegada',
        'data Entrada',
        'hora Entrada',
        'data Entrada Doca',
        'hora Entrada Doca',
        'data Saida Doca',
        'hora Saida Doca',
        'Permanencia na Doca',
        'data Saida',
        'hora Saida'
      ];
    }
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    // Adicione o cabeçalho à planilha e aplique formatação
    const headerRow = worksheet.addRow(columnOrder);
    headerRow.font = { bold: true };
    headerRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'C0C0C0' }
    };

    // Adicione bordas ao cabeçalho
    headerRow.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };

    // Adicione os dados às linhas da planilha
    data.forEach((hora, index) => {
      hora[area].forEach((item: { [x: string]: any; }) => {
        if (item['idContainer'] && item['idContainer'] != "") {
          // console.log(item)
          const dataHoraString = item['Janela'];
          // Extrair a data e a hora da string
          item['dataJanelaDestino1'] = dataHoraString.slice(0, 10); // "2024-04-23"
          item['horaJanelaDestino1'] = dataHoraString.slice(11, 16); // "00:00"
        }
        if (item['dataJanela']) {
          // console.log(item)
          const dataHoraString = item['Janela'];
          // Extrair a data e a hora da string
          item['dataJanelaDestino1'] = item['dataJanela']
          item['horaJanelaDestino1'] = item['horaJanela']
        }
        if (!item['dataJanelaDestino1'] && item['Destino 1'] && item['Destino 1'].includes('SCANIA')) {
          // console.log(item)
          const dataHoraString = item['JanelaDestino 1'];
          // Extrair a data e a hora da string
          item['dataJanelaDestino1'] = dataHoraString.slice(0, 10); // "2024-04-23"
          item['horaJanelaDestino1'] = dataHoraString.slice(11, 16); // "00:00"
        } else if (!item['dataJanelaDestino2'] && item['Destino 2'] && item['Destino 2'].includes('SCANIA')) {
          const dataHoraString = item['JanelaDestino 2'];
          // Extrair a data e a hora da string
          item['dataJanelaDestino2'] = dataHoraString.slice(0, 10); // "2024-04-23"
          item['horaJanelaDestino2'] = dataHoraString.slice(11, 16); // "00:00"
        }
        if (item['ChegadaSCANIA'] && item['ChegadaSCANIA'] != "") {
          const chegadaString = item['ChegadaSCANIA'];
          item['data Chegada'] = chegadaString.slice(0, 10); // "2024-04-23"
          item['hora Chegada'] = chegadaString.slice(11, 16); // "00:00"
        }
        if (item['EntradaSCANIA'] && item['EntradaSCANIA'] != "") {
          const entradaString = item['EntradaSCANIA'];
          item['data Entrada'] = entradaString.slice(0, 10); // "2024-04-23"
          item['hora Entrada'] = entradaString.slice(11, 16); // "00:00"
        }
        if (item['SaidaSCANIA'] && item['SaidaSCANIA'] != "") {
          const saidaString = item['SaidaSCANIA'];
          item['data Saida'] = saidaString.slice(0, 10); // "2024-04-23"
          item['hora Saida'] = saidaString.slice(11, 16); // "00:00"
        }
        if (item['EntradaDocaSCANIA'] && item['EntradaDocaSCANIA'] != "") {
          const entradaString = item['EntradaDocaSCANIA'];
          item['data Entrada Doca'] = entradaString.slice(0, 10); // "2024-04-23"
          item['hora Entrada Doca'] = entradaString.slice(11, 16); // "00:00"
        }
        if (item['SaidaDocaSCANIA'] && item['SaidaDocaSCANIA'] != "") {
          const saidaString = item['SaidaDocaSCANIA'];
          item['data Saida Doca'] = saidaString.slice(0, 10); // "2024-04-23"
          item['hora Saida Doca'] = saidaString.slice(11, 16); // "00:00"
        }
        if ((item['EntradaDocaSCANIA'] && item['EntradaDocaSCANIA'] != "") && (item['SaidaDocaSCANIA'] && item['SaidaDocaSCANIA'] != "" && item['SaidaDocaSCANIA'] != "0001-01-01T00:00:00")) {
          const data1 = new Date(item['SaidaDocaSCANIA']);
          const data2 = new Date(item['EntradaDocaSCANIA']);
          const time1 = data1.getTime();
          const time2 = data2.getTime();
          const diffInMs = Math.abs(time1 - time2);
          // Converter a diferença para minutos e horas
          const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
          const diffInHours = Math.floor(diffInMinutes / 60);
          const remainingMinutes = diffInMinutes % 60;
          item['Permanencia na Doca'] = `${diffInHours}:${remainingMinutes}`;
          // console.log(item['SaidaDocaSCANIA'])
          // console.log(item['EntradaDocaSCANIA'])
          // console.log(diffInMinutes)
          // console.log(diffInHours)
          // console.log(remainingMinutes)
        }

        if (item['Volumes']) {
          const vol = item['Volumes'];
          item['Volumes'] = parseFloat(vol);
        }
        const row = columnOrder.map(column => item[column]);
        const dataRow = worksheet.addRow(row);
        // Adicione bordas aos dados
        dataRow.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
    });

    // Salve o arquivo modificado
    const outputFilePath = 'time_table' + area + '.xlsx';
    const buffer = await workbook.xlsx.writeBuffer();
    const blobData = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    fs.saveAs(blobData, outputFilePath);

    // Exiba um alerta para o usuário baixar o arquivo
    alert('Clique para baixar o arquivo.');
  }

  enableFields() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {
      this.isCarrierEnabled = false;
    }
  }

  enableFieldsTCM() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "TCM")) {
      this.isCarrierTCMEnabled = false;
    }
  }

  enableFieldsJSL() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL")) {
      this.isCarrierJSLEnabled = false;
    }
  }

  enableFieldsJSLARG() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL-ARG")) {
      this.isCarrierJSLARGEnabled = false;
    }
  }

  enableFieldsLOTS() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "LOTS")) {
      this.isCarrierLOTSEnabled = false;
    }
  }

  enableFieldsJSLVW() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL-VW")) {
      this.isCarrierJSLVWEnabled = false;
    }
  }


}
function atualizaStatus(items: any, arg1: any) {
  throw new Error('Function not implemented.');
}

